import React, { Component, PropTypes } from 'react';
import translate from '../../i18n/translate';

class Footer extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { strings, handleUserlangChange } = this.props;
        return (
            <div className="footer hidden-mobile">
                <div className="container">
                    <div className="copyright">{strings.Copyright}
                    </div>
                </div>
            </div>
        );
    }
}

Footer.defaultProps = {
    strings: {}
};

export default translate('Footer')(Footer)



// WEBPACK FOOTER //
// ./client/components/Footer.js